
import React, {useState, useContext, useEffect, useMemo, useCallback} from 'react';
import Radium from 'radium';
import AppConstants from 'AppConstants';
import {Input} from 'views/FormElements';
import ProductTags from 'views/product/ProductTags';

import AppUtil from 'AppUtil';
import Modal from 'react-responsive-modal';

import {ThumbnailLoader} from 'views/order/OrderFormLoader';
import {OrderContext} from 'views/order/OrderForm';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;

const selectedThumbnailStyle = {cursor: "pointer", filter: "opacity(100%)"};
const styles = {
	selectedThumbnail: selectedThumbnailStyle,

	smallThumbnailImg: {filter: "opacity(50%)", 
						boxSizing: "border-box", marginRight: "10px", border: "1px #c1c1c1 solid",
						alignItems: 'center', justifyContent: 'center', display: 'flex',
						overflow: 'hidden',
						":hover": selectedThumbnailStyle},

	largeThumbnail: {cursor: 'pointer', marginBottom: '10px', background: 'white', alignItems: 'center', justifyContent: 'center', display: 'flex', overflow: 'hidden'},
}

export const Thumbnail = ({image, title, style, onImageLoad}) => {
	let thumbnailStyle = Object.assign({}, styles.largeThumbnail);
	const [openModal, setOpenModal] = useState(false);
	
	if(style)
		thumbnailStyle = Object.assign(thumbnailStyle, style);

	return <div style={thumbnailStyle} className="extraLargeImg thumbnailHolder">
				<img src={image} onLoad={onImageLoad} onClick={() => setOpenModal(true)} alt={title+" on SetoCanvas.com"} className='extraLargeImg' />

				<Modal closeOnOverlayClick={true} open={openModal} onClose={() => setOpenModal(false)}
					classNames={{ modal: 'product-image-modal', closeIcon: 'product-image-close-icon' }}>
					<img src={image} alt={title+" on SetoCanvas.com"} />
				</Modal>
		</div>
};

const EachPreview = Radium(({onImgClick, imgSrc, imgStyle, imgTitle}) => {

    return <div className="miniImgContainer" style={imgStyle}>
                <img className='miniImg' src={imgSrc} alt={imgTitle} 
            onClick={() => onImgClick()} />
    </div>
});

const OrderProductImage = () => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const {product, values, setFieldValue} = useContext(OrderContext);
	const defaultProductImage = AppUtil.getDefaultProductImage(product);
	
    const handleSelectProduct = useCallback((imgSrc) => {
		setFieldValue('selectedImage', imgSrc);
		
		if(imgSrc === product.previewImage) {
			setFieldValue('productImage', defaultProductImage);
		} else {
			setFieldValue('productImage', imgSrc);
		}
	}, []);

	const getProductPreviews = useCallback((selectedImage) => {
		let previews = [];
		
		const productType = PRODUCT_TYPES[product.productType].label;

		let images = product.productImages;

		//Note: preview image may not be available and only product image can be available.
		if(product.previewImage)
			images = images.concat(product.previewImage);

		for(var i = 0;i < images.length;i++) {
			const imgSrc = images[i];

			let imgStyle = [styles.smallThumbnailImg];

			if(selectedImage && selectedImage === imgSrc)
				imgStyle.push(styles.selectedThumbnail);

			let imgTitle = product.title;

			if (i === 1) imgTitle += " "+productType+" on SetoCanvas.com";
			else if (i > 1) imgTitle += " "+productType+" "+(i)+" on SetoCanvas.com";


			const preview = <EachPreview onImgClick={() => handleSelectProduct(imgSrc)} 
                                        imgSrc={imgSrc}
                                        imgTitle={imgTitle}
                                        imgStyle={imgStyle} key={i+"-img-"+imgTitle} />;
			previews.push(preview);
		}

		return previews;		
	}, [product]);

	
	useEffect(() => {
		return () => setImageLoaded(false)
	}, [defaultProductImage]);

    const productPreviews = useMemo(() => getProductPreviews(values.selectedImage), [values.selectedImage, product]);

    return <React.Fragment>
            {
                imageLoaded === false &&
                <ThumbnailLoader />
            }

            <Thumbnail style={imageLoaded === false? {display: 'none'}: {}} image={values.selectedImage} title={product.title} onImageLoad={() => setImageLoaded(true)} />

            <div>
                {
                    productPreviews.length > 0 && 
                    <div className="flexRow">
                        {productPreviews}
                    </div>
                }
                
                <ProductTags productTags={product.productTags} />
                <Input name="productImage" type="hidden" mui="off" />
            </div>
        </React.Fragment>
};


export default OrderProductImage;


// WEBPACK FOOTER //
// ./src/views/order/OrderProductImage.js